import Covenant from '../../covenant/covenant'
import Schedule from '../../schedule/schedule'
import Graduations from '../components/graduations/graduations'
import Specializations from '../components/specializations/specialization'

export default {
  Covenant,
  Schedule,
  Graduations,
  Specializations
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/components.js